import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import T from '../Utils/Locale';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            return _jsx("p", Object.assign({ className: 'via-viva-red py-6' }, { children: T('errors.generic') }));
        }
        return children;
    }
}
export default ErrorBoundary;
